import { createSlice } from '@reduxjs/toolkit'
const membersSlice = createSlice({
    name: 'members',
    initialState: {
      members: [
        
      ],
      membersCategory: []
    }
    ,
    reducers: {
        updateMembers: (state, action) => {
            state.members = action.payload;
        },
        updateMembersCategory: (state, action) => {
          state.membersCategory = action.payload
      }
    }
})

export const {updateMembers, updateMembersCategory} = membersSlice.actions;
export default membersSlice.reducer;
